module.exports = __webpack_public_path__ + "img/News_YD.7fad43c9.webp";